export interface GalleryTemplate {
  template: string;
  /** File name in public/templates, without .json */
  id: string;
}

const designTemplates: GalleryTemplate[] = [
  "components-v7",
  "bricks",
  "cars",
  "flowers",
  "leaves",
  "ocean",
  "winter",
].map((name) => ({
  template: name.charAt(0).toUpperCase() + name.slice(1),
  id: `${name}-job-list`,
}));

// Built by scripts/standard-templates/build.mjs; the same pages career-sites-server gives a new tenant
const standardTemplates: GalleryTemplate[] = [
  { template: "Standard job list (EN)", id: "standard-job-list-en" },
  { template: "Standard job list (SV)", id: "standard-job-list-sv" },
  { template: "Standard job list (NB)", id: "standard-job-list-nb" },
  { template: "Standard job list (DA)", id: "standard-job-list-da" },
  { template: "Standard job list (FI)", id: "standard-job-list-fi" },
  { template: "Standard job ad ReachMee (EN)", id: "standard-job-ad-reachmee-en" },
  { template: "Standard job ad ReachMee (SV)", id: "standard-job-ad-reachmee-sv" },
  { template: "Standard job ad ReachMee (NB)", id: "standard-job-ad-reachmee-nb" },
  { template: "Standard job ad ReachMee (DA)", id: "standard-job-ad-reachmee-da" },
  { template: "Standard job ad ReachMee (FI)", id: "standard-job-ad-reachmee-fi" },
  { template: "Standard job ad Talent Recruiter (EN)", id: "standard-job-ad-talent-recruiter-en" },
  { template: "Standard job ad Talent Recruiter (SV)", id: "standard-job-ad-talent-recruiter-sv" },
  { template: "Standard job ad Talent Recruiter (NB)", id: "standard-job-ad-talent-recruiter-nb" },
  { template: "Standard job ad Talent Recruiter (DA)", id: "standard-job-ad-talent-recruiter-da" },
  { template: "Standard job ad Talent Recruiter (FI)", id: "standard-job-ad-talent-recruiter-fi" },
];

export const galleryTemplates: GalleryTemplate[] = [...designTemplates, ...standardTemplates];
